// extracted by mini-css-extract-plugin
module.exports = {"className":"textLabelS_className__Eccu_"};